export default __webpack_public_path__ + "static/media/053-favorite.1d8db5fd.svg";